// extracted by mini-css-extract-plugin
module.exports = {"kicker":"kicker__3o1rK"};